import { Result } from "antd";
import styled from "styled-components";

export const TOBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
  flex-wrap: wrap;
  margin-top: 2em;
`;

export const TOActiveBox = styled.div`
  width: 30vw;
  min-width: 300px;
  margin: 0 auto;
  padding: 1em;
  border-radius: 8px;
  background: ${(props) => (props.active ? "#67E0A3" : "#fff")};
  cursor: ${(props) => (props.active ? "not-allowed" : "pointer")};
  color: #37323e;
  font-size: 14px;
  border: 0.5px solid #37323e;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    font-size: 18px;
  }

  span {
    font-weight: 700;
  }
`;

export const NoBoxResult = styled(Result)`
  min-height: ${(props) => (props.success ? "max-content" : "60vh")};
  margin: ${(props) => (props.success ? "auto auto 2em auto" : "auto")};
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;
